import { UserRole } from "../../features/authentication/models/UserRole";

export const ADMIN: string ="Administrator"
export const REGULAR: string = "Designer";

export const USER_ROLE_MAP: Map<UserRole, string> =
  new Map<UserRole, string>()
    .set(UserRole.Administrator, ADMIN)
    .set(UserRole.Regular, REGULAR);
